"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppGrid = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importDefault(require("react"));
const useSize_1 = require("../../useSize");
const AppCard_1 = require("../AppCard");
const AppGrid = ({ plugins }) => {
    const [size, onLayout] = useSize_1.useSize();
    return (react_1.default.createElement(components_1.Container, null,
        react_1.default.createElement(components_1.Row, null, plugins.map(plugin => (react_1.default.createElement(components_1.Column, { key: plugin.key, onLayout: onLayout, xl: 1, lg: 1.5, md: 2, sm: 3, xs: 3 }, size ? react_1.default.createElement(AppCard_1.AppCard, { plugin: plugin, size: size.width }) : null))))));
};
exports.AppGrid = AppGrid;
exports.AppGrid.displayName = 'AppGrid';
